import { IEditWatchState } from './editWatchContext';
import { EditWatchActionTypes, TEditWatchAction } from './editWatchActions';

export const editWatchReducer = (state: IEditWatchState, action: TEditWatchAction): IEditWatchState => {
	switch (action.type) {
		case EditWatchActionTypes.SET_ALL_DATA:
			return {
				...state,
				watchID: action.payload.watchID,
				serialNumber: action.payload.serialNumber,
				IDSelectedCustomer: action.payload.IDSelectedCustomer,
				IDSelectedRestaurant: action.payload.IDSelectedRestaurant,
				isActive: action.payload.isActive,
			};
		case EditWatchActionTypes.REFETCH_DATA:
			return {
				...state,
				needRefetchData: action.payload.needRefetchData,
			};
		case EditWatchActionTypes.CHANGE_LOADER_STATUS:
			return {
				...state,
				isLoading: action.payload.isLoading,
			};
		case EditWatchActionTypes.CHANGE_SERIAL_NUMBER:
			return {
				...state,
				serialNumber: action.payload.serialNumber,
			};
		case EditWatchActionTypes.SET_ID_CUSTOMER:
			return {
				...state,
				IDSelectedCustomer: action.payload.IDSelectedCustomer,
				IDSelectedRestaurant: null,
			};
		case EditWatchActionTypes.SET_ID_RESTAURANT:
			return {
				...state,
				IDSelectedRestaurant: action.payload.IDSelectedRestaurant,
			};
		case EditWatchActionTypes.SET_DATA_FOR_SUBMIT:
			return {
				...state,
				dataForSubmit: action.payload.dataForSubmit,
			};
		case EditWatchActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case EditWatchActionTypes.SHOW_ERROR_MODAL_WITH_INFO:
			return {
				...state,
				errorResponseData: action.payload.errorResponseData,
			};
		default:
			return state;
	}
};
